export enum DocumentTypeEnum {
  WAYBILL = 'waybilll',
  DOCUMENT = 'document',
}
